export enum Permission {
  // Organization
  ORG_UPDATE = 'org:organization:update',

  // Branding
  BRANDING_UPDATE = 'org:branding:update',

  // Billing
  BILLING_UPDATE = 'org:billing:update',

  // Membership
  MEMBERSHIP_CREATE = 'org:membership:create',
  MEMBERSHIP_UPDATE = 'org:membership:update',
  MEMBERSHIP_DELETE = 'org:membership:delete',

  // Space
  SPACE_READ = 'org:space:read',
  SPACE_CREATE = 'org:space:create',
  SPACE_UPDATE = 'org:space:update',
  SPACE_DELETE = 'org:space:delete',

  // Stay
  STAY_READ = 'org:stay:read',
  STAY_CREATE = 'org:stay:create',
  STAY_UPDATE = 'org:stay:update',
  STAY_DELETE = 'org:stay:delete',

  // Guest
  GUEST_READ = 'org:guest:read',
  GUEST_CREATE = 'org:guest:create',
  GUEST_UPDATE = 'org:guest:update',
  GUEST_DELETE = 'org:guest:delete',

  // File
  FILE_CREATE = 'org:file:create',
  FILE_UPDATE = 'org:file:update',

  // Goodie
  GOODIE_CREATE = 'org:goodie:create',
  GOODIE_UPDATE = 'org:goodie:update',
  GOODIE_DELETE = 'org:goodie:delete',

  // Promotion
  PROMOTION_CREATE = 'org:promotion:create',
  PROMOTION_UPDATE = 'org:promotion:update',
  PROMOTION_DELETE = 'org:promotion:delete',

  // Order
  ORDER_READ = 'org:order:read',
  ORDER_UPDATE = 'org:order:update',
  ORDER_DELETE = 'org:order:delete',

  // Event Occurrence
  EVENT_OCCURRENCE_UPDATE = 'org:event_occurence:update',

  // Layout
  LAYOUT_READ = 'org:layout:read',
  LAYOUT_CREATE = 'org:layout:create',
  LAYOUT_UPDATE = 'org:layout:update',
  LAYOUT_DELETE = 'org:layout:delete',

  // Feedback
  FEEDBACK_READ = 'org:feedback:read',
  FEEDBACK_UPDATE = 'org:feedback:update'
}
